import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Box,
  Typography,
  IconButton,
  Breadcrumbs,
  Button,
  Tooltip,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { generatePath, Link } from 'react-router-dom';
import { Home } from '@mui/icons-material';
import { useIntl } from 'react-intl';
import {
  StyledRescuerBreadcrumb,
  StyledRescuerTextBreadcrumb,
} from '../../../rescuerDashboard/rescuerDashboardMobile/Components/StyledRescuerBreadcrumb';
import routes from '../../../../routes';

const FoodDonorMobileLocationsBreadcrumb = () => {
  const { formatMessage } = useIntl();

  return (
    <Box boxShadow={0}>
      <Breadcrumbs aria-label="breadcrumb">
        <StyledRescuerBreadcrumb
          component={Link}
          to={generatePath(routes.mobileDashboard)}
          label={formatMessage({ id: 'breadcrumbs.home' })}
          icon={<Home style={{ color: '#fff' }} fontSize="small" />}
        />
        <StyledRescuerTextBreadcrumb
          component="a"
          href="#"
          label={formatMessage({ id: 'breadcrumbs.food-donor-locations' })}
        />
      </Breadcrumbs>
    </Box>
  );
};

const FoodDonorMobileLocationsList = ({ onEdit, onAdd, pickupLocations = [] }) => (
  <>
    <FoodDonorMobileLocationsBreadcrumb />

    <Box py={2} px={1}>
      <Box pb={2}>
        <Typography variant="h6">Pickup Locations</Typography>
      </Box>
      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableBody>
            {pickupLocations.map((location) => (
              <TableRow key={location.id}>
                <TableCell sx={{ maxWidth: 0, width: '35%' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Tooltip title={location.name}>
                      <Typography noWrap sx={{ fontSize: 13 }}>
                        {location.name}
                      </Typography>
                    </Tooltip>
                  </Box>
                </TableCell>
                <TableCell sx={{ maxWidth: 0, width: '45%' }}>
                  <Tooltip title={location.address}>
                    <Typography noWrap sx={{ fontSize: 12, color: 'text.secondary' }}>
                      {location.address}
                    </Typography>
                  </Tooltip>
                </TableCell>
                <TableCell align="center" sx={{ width: 90, flexShrink: 0 }}>
                  <IconButton size="small" color="primary" onClick={() => onEdit(location.id)}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>

    <Box px={1}>
      <Button fullWidth variant="contained" color="primary" onClick={onAdd}>
        Add Location
      </Button>
    </Box>
  </>
);

export default FoodDonorMobileLocationsList;
